"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PriceFilterInput = _interopRequireDefault(require("./components/PriceFilterInput"));
var _PriceFilterSegments = _interopRequireDefault(require("./components/PriceFilterSegments"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PriceFilter = function PriceFilter(_ref) {
  var _ref$externalMin = _ref.externalMin,
    externalMin = _ref$externalMin === void 0 ? 0 : _ref$externalMin,
    _ref$externalMax = _ref.externalMax,
    externalMax = _ref$externalMax === void 0 ? 0 : _ref$externalMax,
    minBound = _ref.minBound,
    maxBound = _ref.maxBound,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return null;
    } : _ref$onChange,
    _ref$segments = _ref.segments,
    segments = _ref$segments === void 0 ? [] : _ref$segments,
    className = _ref.className,
    currencyCode = _ref.currencyCode;
  var _useState = (0, _react.useState)(externalMin),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    minVal = _useState2[0],
    setMinVal = _useState2[1];
  var _useState3 = (0, _react.useState)(externalMax),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    maxVal = _useState4[0],
    setMaxVal = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedSegment = _useState6[0],
    setSelectedSegment = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    hoveredSegment = _useState8[0],
    setHoveredSegment = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    suggestedMin = _useState10[0],
    setSuggestedMin = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    suggestedMax = _useState12[0],
    setSuggestedMax = _useState12[1];
  var debouncedChangeCallback = (0, _react.useCallback)((0, _debounce2["default"])(onChange, 1000), [onChange]);
  var onSegmentHovered = (0, _react.useCallback)(function (segment) {
    setHoveredSegment(segment);
  }, [hoveredSegment]);
  var onSegmentClicked = (0, _react.useCallback)(function (segment) {
    var id = segment.id;
    if (selectedSegment && id === selectedSegment.id) {
      setSelectedSegment(undefined);
      setMinVal(0);
      setMaxVal(0);
      onChange({
        min: undefined,
        max: undefined
      });
    } else {
      setSelectedSegment(segment);
      var from = segment.from,
        to = segment.to;
      setMinVal(from);
      setMaxVal(to);
      onChange({
        min: from,
        max: to
      });
    }
  }, [selectedSegment]);
  var handleChangeMin = (0, _react.useCallback)(function (min) {
    setMinVal(min);
    debouncedChangeCallback({
      min: min,
      max: maxVal
    });
  }, [maxVal]);
  var handleChangeMax = (0, _react.useCallback)(function (max) {
    setMaxVal(max);
    debouncedChangeCallback({
      min: minVal,
      max: max
    });
  }, [minVal]);

  /**
   * Чтобы можно было из монолита менять текущую цену фильтров
   * (Например, при применении предыдущих фильтров)
   */
  (0, _react.useEffect)(function () {
    setMinVal(externalMin);
  }, [externalMin]);
  (0, _react.useEffect)(function () {
    setMaxVal(externalMax);
  }, [externalMax]);
  (0, _react.useEffect)(function () {
    if (hoveredSegment) {
      var from = hoveredSegment.from,
        to = hoveredSegment.to;
      setSuggestedMin(from);
      setSuggestedMax(to);
    } else {
      setSuggestedMin(undefined);
      setSuggestedMax(undefined);
    }
  }, [hoveredSegment]);
  (0, _react.useEffect)(function () {
    var selectedDefault = segments && segments.find(function (s) {
      return s.from === externalMin && s.to === externalMax;
    });
    if (selectedDefault) {
      setSelectedSegment(selectedDefault);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    className: className
  }, segments !== null && segments !== void 0 && segments.length ? /*#__PURE__*/_react["default"].createElement(StyledPriceFilterSegments, {
    segments: segments,
    min: minBound,
    max: maxBound,
    onClick: onSegmentClicked,
    onSegmentHovered: onSegmentHovered,
    selectedId: selectedSegment === null || selectedSegment === void 0 ? void 0 : selectedSegment.id
  }) : null, /*#__PURE__*/_react["default"].createElement(StyledInputGroup, null, /*#__PURE__*/_react["default"].createElement(_PriceFilterInput["default"], {
    label: "\u043E\u0442",
    value: suggestedMin || minVal,
    onChange: handleChangeMin,
    placeholder: minBound,
    currencyCode: currencyCode
  }), /*#__PURE__*/_react["default"].createElement(_PriceFilterInput["default"], {
    label: "\u0434\u043E",
    value: suggestedMax || maxVal,
    onChange: handleChangeMax,
    placeholder: maxBound,
    currencyCode: currencyCode
  })));
};
var StyledInputGroup = _styledComponents["default"].div.withConfig({
  displayName: "PriceFilter__StyledInputGroup",
  componentId: "sc-mrsom0-0"
})(["display:flex;align-items:center;flex-shrink:0;gap:2px;"]);
var StyledPriceFilterSegments = (0, _styledComponents["default"])(_PriceFilterSegments["default"]).withConfig({
  displayName: "PriceFilter__StyledPriceFilterSegments",
  componentId: "sc-mrsom0-1"
})(["margin-bottom:8px;"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "PriceFilter__StyledContainer",
  componentId: "sc-mrsom0-2"
})(["display:flex;height:100%;flex-direction:column;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(PriceFilter);